import React, { forwardRef } from 'react';

import CommonNotification from './CommonNotification';
import { ICONS } from '../icons';

const WarningNotification = forwardRef(
  ({ id, message, subMessage, messageParams, subMessageParams, showMarkerText, subMessageWithContactLink }, ref) => {
    return (
      <CommonNotification
        id={id}
        ref={ref}
        message={message}
        messageParams={messageParams}
        subMessage={subMessage}
        subMessageParams={subMessageParams}
        showMarkerText={showMarkerText}
        subMessageWithContactLink={subMessageWithContactLink}
        MarkerIcon={ICONS.Info}
        markerText='warning'
        markerStyle='warning'
      />
    );
  },
);
WarningNotification.displayName = 'WarningNotification';

export default WarningNotification;
